import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.css'],
  standalone: false,
})
export class ChangelogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
